// http://emailregex.com/
export const EMAIL =
  /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
export const EMAILS = /([a-zA-Z0-9._+-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi
export const ONE_NUM = /[\d]{1}/

export const ONE_LOWER_AND_UPPER = /(?=.*[a-z])(?=.*[A-Z])/

export const ALL_SPACES = /\s+/g
